window.filterData = [
  {
    name: "NIRA PRO LASER",
    tabid: "pro_laser",
    resultId: "by_area",
    heading: "In Our Clinical Study",
    slides: [
      {
        label: "Full face",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_MAIN_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_MAIN_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/wrinkle_before_1_1600x.png?v=1686069112",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/wrinkle_after_1_1600x.png?v=1686069112",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_4_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_4_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/200.jpg?v=1700836980",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/201.jpg?v=1700836980",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_4_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_4_after.jpg?v=1686487443",
          },
        ],
      },
      {
        label: "NECK & CHEST",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_471.png?v=1686486451",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_472_1_25746b15-9edc-4796-a2c9-1170badde7bd.png?v=1686486452",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_2_before.jpg?v=1686486451",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_2_after.jpg?v=1686486451",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_472_1.png?v=1686486451",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_472_2.png?v=1686486451",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/neck_before_1.jpg?v=1702324543",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/neck_after_1.jpg?v=1702324543",
          },
        ],
      },
      {
        label: "Hands",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_1_before.jpg?v=1686486978",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_1_after.jpg?v=1686486978",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_687.png?v=1686486965",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_687.png?v=1686486965",
          },
        ],
      },
    ],
  },
  {
    name: "NIRA PRO LASER",
    tabid: "pro_laser",
    resultId: "by_skin",
    heading: "In Our Clinical Study",
    slides: [
      {
        label: "Wrinkles",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/wrinkle_before_1_1600x.png?v=1686069112",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/wrinkle_before_1_1600x.png?v=1686069112",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/BEFORE_3_562db776-a0c3-4113-898a-c34e8e9ae799_1600x.jpg?v=1685459174",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/AFTER_3_b876d6e3-a0d3-4f64-8cd9-dc0e0d7e69e1_1600x.jpg?v=1685459176",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Before_2.jpg?v=1686487442",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_After_2.jpg?v=1686487441",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/wrinkle_before_2_b3691166-2700-4791-be76-2315e5706cc2_1600x.png?v=1686069185",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/wrinkle_after_2_1600x.png?v=1686069112",
          },
        ],
      },
      {
        label: "skin tone",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_MAIN_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_MAIN_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/skin_before_5_45dec5f3-bd63-4f10-aac3-b3f1d640ea35_1600x.png?v=1686113329",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/skin_after_5_1600x.png?v=1686113328",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_MAIN_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_1_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_BEFORE_CHEST.jpg?v=1686489599",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_AFTER_CHEST.jpg?v=1686489598",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_2_before.jpg?v=1686490127",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_tone_2_after.jpg?v=1686490128",
          },
        ],
      },
      {
        label: "skin texture",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_MAIN_before.jpg?v=1686487446",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_MAIN_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_texture_3_before.jpg?v=1686488744",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_texture_3_after.jpg?v=1686488744",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_1_before.jpg?v=1686486978",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_1_after.jpg?v=1686486978",
          },

          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_4_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_texture_4_after.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_texture_2_before.jpg?v=1686489011",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_texture_2_after.jpg?v=1686489011",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_texture_5_before.jpg?v=1686489011",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_texture_5_after.jpg?v=1686489011",
          },
        ],
      },
      {
        label: "sagging skin",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_main_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_main_after_1.jpg?v=1686487443",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_481.png?v=1686488126",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_482.png?v=1686488126",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_2_before.jpg?v=1686486451",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_2_after.jpg?v=1686486451",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_484_923da3d1-a6a7-4939-a658-6f67d6b18601.png?v=1686488126",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Rectangle_483_0f1e7db1-376a-4ec5-b71b-299f51e34c9c.png?v=1686488126",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_4_before.jpg?v=1686487443",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_sag_4_before.jpg?v=1686487443",
          },
        ],
      },
    ],
  },
  {
    name: "NIRA Precision Laser",
    tabid: "precision_laser",
    resultId: "by_area",
    heading: "In Our Clinical Study",
    slides: [
      {
        label: "Eyes",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V1_P5_Before_007baafb-2ba2-46f9-80ce-ce9fee2f0346.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_1f5a5fd8-1c2d-4648-ae7c-0f611b444755.jpg?v=1686483905",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V1_P3_Before_e5c5688b-9293-4330-95ae-02b9bc26d5b0.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V6_P3_After_300876d2-3cd7-4b09-9dc4-de3592afd30c.jpg?v=1686483905",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V1_P5_Before_007baafb-2ba2-46f9-80ce-ce9fee2f0346.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_1f5a5fd8-1c2d-4648-ae7c-0f611b444755.jpg?v=1686483905",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V1_P5_Before_3.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V6_P5_After_3.jpg?v=1686483906",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/143_V1_P3_4fe83779-dd26-480f-9a64-710094a8dddf.jpg?v=1686483905",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/143_V7_P3_dfe17dfe-503c-4470-b04b-ad5e4d5fc41a.jpg?v=1686483906",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/138_V1_P4_Before_369b120b-5b10-48b0-88b7-7071cdbbbeb2.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/138_V7_P4_After_8c08b9ea-4673-4687-a838-52c3c50b0d00.jpg?v=1686483906",
          },
        ],
      },
      {
        label: "Mouth",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_1_before.jpg?v=1686485567",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_1_after.jpg?v=1686485568",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_3_before.jpg?v=1686485568",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_3_after.jpg?v=1686485568",
          },
        ],
      },
    ],
  },
  {
    name: "NIRA Precision Laser",
    tabid: "precision_laser",
    resultId: "by_skin",
    heading: "In Our Clinical Study",
    slides: [
      {
        label: "Eye Wrinkles",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V1_P5_Before_007baafb-2ba2-46f9-80ce-ce9fee2f0346.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_1f5a5fd8-1c2d-4648-ae7c-0f611b444755.jpg?v=1686483905",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V1_P3_Before_e5c5688b-9293-4330-95ae-02b9bc26d5b0.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V6_P3_After_300876d2-3cd7-4b09-9dc4-de3592afd30c.jpg?v=1686483905",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V1_P5_Before_007baafb-2ba2-46f9-80ce-ce9fee2f0346.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_1f5a5fd8-1c2d-4648-ae7c-0f611b444755.jpg?v=1686483905",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V1_P5_Before_3.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/160_V6_P5_After_3.jpg?v=1686483906",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/143_V1_P3_4fe83779-dd26-480f-9a64-710094a8dddf.jpg?v=1686483905",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/143_V7_P3_dfe17dfe-503c-4470-b04b-ad5e4d5fc41a.jpg?v=1686483906",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/138_V1_P4_Before_369b120b-5b10-48b0-88b7-7071cdbbbeb2.jpg?v=1686483906",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/138_V7_P4_After_8c08b9ea-4673-4687-a838-52c3c50b0d00.jpg?v=1686483906",
          },
        ],
      },
      {
        label: "Hooded Eyes",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_MAIN_BEFORE.jpg?v=1686484639",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_MAIN_After.jpg?v=1686484639",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_4.jpg?v=1686484639",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_5.jpg?v=1686484639",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_Before.jpg?v=1686484639",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_After_2.jpg?v=1686484639",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_160_V1_P5_Before.jpg?v=1686484934",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_160_V6_P5_After.jpg?v=1686484639",
          },
        ],
      },
      {
        label: "Mouth Wrinkles",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_1_before.jpg?v=1686485567",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_1_after.jpg?v=1686485568",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_3_before.jpg?v=1686485568",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/Copy_of_Copy_of_sag_3_after.jpg?v=1686485568",
          },
        ],
      },
      {
        label: "DARK CIRCLES",
        progress: [
          {
            fill: "99",
            text: "said treatments are quick and easy",
          },
          {
            fill: "93",
            text: "loved their results",
          },
          {
            fill: "90",
            text: "would recommend the device to others",
          },
        ],
        images: [
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_90df4098-7ef5-45ec-9361-8186e41f16bb_1600x.jpg?v=1685597146",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/118_BEFORE_P5_e8274e38-3fb6-403d-8301-754cc3f4acad_1600x.jpg?v=1685597146",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_90df4098-7ef5-45ec-9361-8186e41f16bb_1600x.jpg?v=1685597146",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/118_BEFORE_P5_e8274e38-3fb6-403d-8301-754cc3f4acad_1600x.jpg?v=1685597146",
          },
          {
            before:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/139_V6_P5_After_90df4098-7ef5-45ec-9361-8186e41f16bb_1600x.jpg?v=1685597146",
            after:
              "https://cdn.shopify.com/s/files/1/0073/0231/6068/files/118_BEFORE_P5_e8274e38-3fb6-403d-8301-754cc3f4acad_1600x.jpg?v=1685597146",
          },
        ],
      },
    ],
  },
];
